export default {
  id: 110,
  title: 'Target #110 - Sunrays',
  url: 'https://cssbattle.dev/play/110',
  colors: ['#D25B70', '#F2E09F'],
  solution:
    '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#d25b70}a{top:195;left:80;width:100;height:10;position:fixed;background:#f2e09f;border-radius:9in;transform-origin:120px}[a]{transform:rotate(0)}[b]{transform:rotate(30deg)}[c]{transform:rotate(60deg)}[d]{transform:rotate(90deg)}[e]{transform:rotate(120deg)}[f]{transform:rotate(150deg)}[g]{transform:rotate(180deg)}</style>',
}
